import { BooleanOperator } from 'src/enums/stowage/stowageRule/booleanOperator';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { StowageRuleId } from 'src/enums/stowage/stowageRule/stowageRuleId';
import { StowageRulePropertyLocation } from 'src/enums/stowage/stowageRule/stowageRulePropertyLocation';
import { StowageRulePropertyOperator } from 'src/enums/stowage/stowageRule/stowageRulePropertyOperator';
import { StowageRuleTestScope } from 'src/enums/stowage/stowageRule/stowageRuleTestScope';
import { StowageRuleBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRuleBM';

export const manualCargoOperationInDepartedCallSoftRule: StowageRuleBM = {
    id: StowageRuleId.ManualCargoOperationInDepartedCallSoftRule,
    name: 'A manual cargo operation cannot be included in a departed call.',
    lastUpdatedUtc: '2025-01-07T00:00:00.000',
    condition: {
        operator: BooleanOperator.AND,
        children: [
            {
                leaf: {
                    properties: [
                        {
                            name: 'Is cargo operation a manual Loading or Unloading operation',
                            fieldPath: 'isManualLoadingOrUnloadingOperation',
                            type: 'boolean',
                            location: StowageRulePropertyLocation.NA,
                        },
                        {
                            name: 'Reference value',
                            type: 'boolean',
                            referenceValue: 'true',
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.CargoOperation,
                    operator: StowageRulePropertyOperator.Equals,
                },
            },
            {
                leaf: {
                    properties: [
                        {
                            name: 'Is port call departed',
                            fieldPath: 'isPortCallDeparted',
                            type: 'boolean',
                            location: StowageRulePropertyLocation.NA,
                        },
                        {
                            name: 'Reference value',
                            type: 'boolean',
                            referenceValue: 'true',
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.CargoOperation,
                    operator: StowageRulePropertyOperator.Equals,
                },
            },
        ],
    },
    consequence: {
        type: StowageRuleConsequenceType.SoftRule,
        parameter: 'Manual cargo operation in departed port call',
    },
};
